import { render, staticRenderFns } from "./UpdateSciApplication.vue?vue&type=template&id=e8502ef2"
import script from "./UpdateSciApplication.vue?vue&type=script&lang=js"
export * from "./UpdateSciApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports